import { useCallback, useEffect, useState } from 'react';
import { logError } from '@bonanza-social/toolkit/logging';
import { DataState } from '@bonanza-social/toolkit/state';
import { Game, GameInfo } from '../state/shared/games.types';
import GamesService from '../services/GamesService/GamesService';

const useGameInfo = (id?: Game['id']) => {
  const [data, setData] = useState<GameInfo>();
  const [dataState, setDataState] = useState<DataState>('idle');

  const fetch = useCallback(async () => {
    if (!id) {
      return;
    }

    try {
      setDataState('pending');

      const data = await GamesService.getGameInfo({
        pathParams: { gameId: id },
      });

      setData(data);
      setDataState('fulfilled');
    } catch (error) {
      logError('Game details request failure.', error, { id });

      setDataState('rejected');
    }
  }, [id]);

  useEffect(() => {
    fetch();
  }, [fetch]);

  return { data, dataState };
};

export default useGameInfo;
